import * as type from '../../types/API/storeTypes'

export function addStores(payload: any) {
    return {
        type: type.ADD_STORE,
        payload: payload
    }
}

export function getStores(payload: any) {
    return {
        type: type.GET_STORE,
        payload: payload
    }
}

export function getStoreById(payload: any) {
    return {
        type: type.GET_STORE_BY_ID,
        payload: payload
    }
}

export function getStoreByItems(payload: any) {
    return {
        type: type.GET_STORE_BY_ITEMS,
        payload: payload
    }
}

export function editStores(payload: any) {
    return {
        type: type.EDIT_STORE,
        payload: payload
    }
}

export function deleteStores(payload: any) {
    return {
        type: type.DELETE_STORE,
        payload: payload
    }
}

export function getStoreWithItems(payload: any) {
    return {
        type: type.GET_STORE_BY_ITEM,
        payload: payload
    }
}

export function getAllItemWithStoreID(payload: any) {
    return {
        type: type.GET_ALL_STORE_ITEMS_BY_STORES_ID,
        payload: payload
    }
}

export function getAllStoresWithItems(payload: any) {
    return {
        type: type.GET_ALL_STORES_WITH_ITEMS,
        payload: payload
    }
}

export function getAllStocksValues(payload: any) {
    return {
        type: type.GET_ALL_STOCKS_VALUES,
        payload: payload
    }
}

export function getFifoPrice(payload: any) {
    return {
        type: type.GET_FIFO_PRICE,
        payload: payload
    }
}

export function setDefaultStore(payload: any) {
    return {
        type: type.SET_DEFAULT_STORE,
        payload: payload
    }
}